<template>
    <div>
        <img class="no_permission_center" :src="background" alt="">
        <!--Title-->
            <div class="text-center col-md-12">
            <router-link to="/">
                    <p-button type="warning" >
                        <i class="mr-2 fa fa-arrow-left"></i>Volver al inicio
                    </p-button>
            </router-link>
            </div>
            <!--./Title-->
    </div>
    
    </template>
    <script>
    import {Card, Checkbox, Button, InfoSection} from 'src/components/UIComponents';
    import AppNavbar from './../Dashboard/Views/Pages/Layout/AppNavbar'
    import AppFooter from './../Dashboard/Views/Pages/Layout/AppFooter'
    export default {
        components: {
        Card,
        AppNavbar,
        AppFooter,
        InfoSection,
        [Checkbox.name]: Checkbox,
        [Button.name]: Button
        },
        data(){
        return{
            background: process.env.VUE_APP_BASE_ROUTE+'img/401.png'
        }
        },
        methods: {
        toggleNavbar () {
            document.body.classList.toggle('nav-open')
        },
        closeMenu () {
            document.body.classList.remove('nav-open')
            document.body.classList.remove('off-canvas-sidebar')
        }
        },
        beforeDestroy () {
        this.closeMenu()
        }
    }
    </script>
    <style>
    .no_permission_center {
        display: block;
        margin-top: 10em;
        margin-bottom: auto;
        margin-left: auto;
        margin-right: auto;
        width: 50%;
    }
</style>
